import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './language/enTranslation.json'; // Переименованный файл английского перевода
import ruTranslation from './language/ruTranslation.json'; // Переименованный файл русского перевода

const language = localStorage.getItem('language') || (navigator.language.startsWith('ru') ? 'ru' : 'en'); // Выбор языка из localStorage

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    ru: {
      translation: ruTranslation,
    },
  },
  lng: language === 'Русский' ? 'ru' : 'en', // Устанавливаем язык
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
